import PlacementType from './placement-type';
import BoardType from './board-type';
import GenericModel from '../../generic-model';
import HeightAndWidthAware from '../../helper-interfaces/height-and-width-aware';
import { SignSize } from './sign-size';
import Color, { ColorChoices } from '../../color';
import Material from '../../material/material';
import { INT_MAX_SIGNED_32_BIT_VALUE } from 'src/globals/globals';

export default class BoardPart
  extends GenericModel
  implements HeightAndWidthAware
{
  height?: number;
  width?: number;
  boardType?: BoardType;
  placementType?: PlacementType;
  otherPlacementType?: string;
  material?: Material;
  otherMaterial?: string;
  distanceToBottom?: number;
  distanceToBottomText?: string;
  paintedPosts?: boolean;
  paintedPostsValue?: Color;
  paintedPostsText?: string;
  layoutDescription?: string;
  signSize?: SignSize;
  showDistanceToBottom?: boolean; // frontend only

  public canSubmitAsClient(): boolean {
    return this.height != null && this.width != null;
  }
}

export const BoardTypeChoices = {
  SINGLE_SIDED: new BoardType('Enkel bord', 0),
  DOUBLE_SIDED: new BoardType('Dubbelzijdig bord', 1),
  V: new BoardType('V-bord', 2),
  DIVERGENT: new BoardType('Afwijkend', INT_MAX_SIGNED_32_BIT_VALUE),
};

export const BoardTypeChoiceArray = Object.values(BoardTypeChoices).filter(
  (t) => t.ordinal !== INT_MAX_SIGNED_32_BIT_VALUE
);

export const PlacementTypeChoices = {
  ATTACHED_TO_FACADE: new PlacementType('Gevel', 0),
  STRETCHED: new PlacementType('Opgespannen', 1),
  ON_POSTS: new PlacementType('Palen', 2),
  ON_STONES: new PlacementType('Ballast', 3),
  OTHER: new PlacementType('Andere', 4),
};

export const PlacementTypeChoiceArray = Object.values(PlacementTypeChoices);

export const DEFAULT_DISTANCE_TO_BOTTOM = 160;

export const BoardPartHeightsAndWidth: HeightAndWidthAware[][] = [
  [
    { height: 100, width: 200 },
    { height: 125, width: 260 },
  ],
  [
    { height: 150, width: 150 },
    { height: 150, width: 200 },
    { height: 150, width: 300 },
  ],
  [
    { height: 200, width: 150 },
    { height: 200, width: 200 },
    { height: 200, width: 300 },
    { height: 200, width: 400 },
    { height: 200, width: 500 },
  ],
  [
    { height: 300, width: 200 },
    { height: 300, width: 300 },
    { height: 300, width: 400 },
    { height: 300, width: 450 },
    { height: 300, width: 600 },
  ],
  [
    { height: 400, width: 400 },
    { height: 400, width: 600 },
  ],
];

export const PAINTED_POSTS_COLOR_CHOICE_ARRAY: Color[] = [
  ColorChoices.WHITE,
  ColorChoices.BLACK,
  ColorChoices.GRAY,
  ColorChoices.OTHER,
];
